import React, { useState } from "react";
import Container from "./Container.jsx";

const MobileMenuIcon = ({ handleOnClick }) => (
  <div className="hamburger-menu-container">
    <button
      className="hamburger-menu"
      aria-label="Navigation"
      onClick={() => handleOnClick()}
    >
      <div className="menu-line" />
      <div className="menu-line" />
      <div className="menu-line" />
    </button>
  </div>
);

const SubMenu = ({
  idx,
  activeMenuStack,
  setActiveMenuStack,
  icon,
  label,
  description,
  submenuKey,
  submenuItems,
  activeSubmenuHoverTop,
  setActiveSubmenuHoverTop,
  isDesktopSubmenuOpen,
  setIsDesktopSubmenuOpen,
  menuOpen,
}) => {
  const isMobileSubMenuOpen = activeMenuStack.includes(submenuKey) && menuOpen;
  // console.log(submenuItems, submenuItems.some(
  //   (subItem) => subItem.submenuKey && Array.isArray(subItem.submenuItems)
  // ) ? 'has-children-with-subitems' : '');
  return (
    <>
      <div
        className={`menu-header has-submenu`}
        onClick={() => {
          if (!activeMenuStack.includes(submenuKey) && menuOpen) {
            setActiveMenuStack((ams) => [...ams, submenuKey]);
          }
        }}
        onMouseOver={(event) => {
          event.stopPropagation();
          event.preventDefault();
          if (event.target.className !== "menu-description") {
            setIsDesktopSubmenuOpen({
              key: submenuKey,
              idx,
              isNext: isDesktopSubmenuOpen.idx < idx,
            });
            setActiveSubmenuHoverTop(event.target.getBoundingClientRect().height * idx);
          }
        }}
      >
        {icon}
        {label}
        {description && <span className="menu-description">{description}</span>}
      </div>
      <Container
        wrapperClassNames={`menu-items ${
          [...activeMenuStack].pop() === submenuKey ? "menu-items--open" : ""
        } ${
          isDesktopSubmenuOpen.key === submenuKey ||
          (isDesktopSubmenuOpen.idx === undefined &&
            idx === 0)
            ? "desktop-menu-items--open"
            : ""
        } ${
          idx === isDesktopSubmenuOpen.idx - 1 ? "desktop-menu-items--prev" : ""
        } ${
          idx === isDesktopSubmenuOpen.idx + 1 ? "desktop-menu-items--next" : ""
        }
        `}
        contentClassNames={`
          ${submenuItems.some(
            (subItem) => subItem.submenuKey && Array.isArray(subItem.submenuItems)
          ) ? 'has-children-with-subitems' : ''}
        `}
        wrapperStyle={{
          width: isMobileSubMenuOpen
            ? `${200 * activeMenuStack.length}px`
            : undefined,
        }}
      >
        <span className="submenu-header">
          {label}{" "}
          <i
            className="i i--close"
            onClick={() => {
              setActiveMenuStack((ams) => ams.slice(0, -1));
            }}
          />
        </span>

        {submenuItems.some(
          (subItem) => subItem.submenuKey && Array.isArray(subItem.submenuItems)
        ) && (
          <span
            className="active-submenu-hover-background"
            style={activeSubmenuHoverTop ? { top: activeSubmenuHoverTop } : {}}
          ></span>
        )}

        {submenuItems.map((subItem, subIdx) =>
          subItem.submenuKey && Array.isArray(subItem.submenuItems) ? (
            <SubMenu
              key={`submenu-item-${submenuKey}-${subIdx}`}
              idx={subIdx}
              activeMenuStack={activeMenuStack}
              setActiveMenuStack={setActiveMenuStack}
              label={subItem.label}
              description={subItem.description}
              submenuKey={subItem.submenuKey}
              submenuItems={subItem.submenuItems}
              activeSubmenuHoverTop={activeSubmenuHoverTop}
              setActiveSubmenuHoverTop={setActiveSubmenuHoverTop}
              isDesktopSubmenuOpen={isDesktopSubmenuOpen}
              setIsDesktopSubmenuOpen={setIsDesktopSubmenuOpen}
              menuOpen={menuOpen}
            />
          ) : (
            <div
              key={`submenu-item-${submenuKey}-${subIdx}`}
              className={subItem.className || "menu-header"}
            >
              <img src={subItem.icon} style={{height: "25px"}} className="m-b-1 m-r-1"/>
              <a
                href={subItem.href}
                target={subItem.target}
                onClick={subItem.onClick}
              >
                <div className="menu-header-label">{subItem.label}</div>
                {subItem.description && (
                  <div className="menu-description">{subItem.description}</div>
                )}
              </a>
            </div>
          )
        )}
      </Container>
    </>
  );
};

const Menu = ({
  activeMenuStack,
  setActiveMenuStack,
  menuItems,
  menuOpen,
  handleMenuOnClick,
}) => {
  const [activeSubmenuHoverTop, setActiveSubmenuHoverTop] = useState(null);
  const [isDesktopSubmenuOpen, setIsDesktopSubmenuOpen] = useState(false);

  return (
    <Container
      name="navigation-menu"
      wrapperClassNames={`${menuOpen ? "mobile-menu-open" : ""} ${
        activeMenuStack.length > 0 ? "mobile-submenu-open" : ""
      }`}
      wrapperStyle={{
        left: menuOpen ? `${-200 * activeMenuStack.length}px` : undefined,
      }}
    >
      <Container
        contentClassNames="navigation-menu-columns navigation-login-mobile-main-header"
        name="navigation-login-mobile"
      >
        <span className="menu-header">
          <a href="/">
            <img
              src="/assets/img/logos/footer-mark.svg"
              height="20px"
              title="ArtCloud"
              alt="ArtCloud"
            />
          </a>
          <i className="i i--close" onClick={() => handleMenuOnClick()} />
        </span>
      </Container>
      {menuItems.map((item, idx) => {
        return (
          <Container
            contentClassNames="navigation-menu-columns"
            name={
              item.isMobileOnly
                ? "navigation-login-mobile"
                : `navigation-menu-${idx}`
            }
            key={`menu-item-${idx}`}
          >
            {item.submenuKey && Array.isArray(item.submenuItems) ? (
              <SubMenu
                key={`submenu-item-${item.submenuKey}-${idx}`}
                idx={undefined}
                activeMenuStack={activeMenuStack}
                setActiveMenuStack={setActiveMenuStack}
                icon={item.icon}
                label={item.label}
                description={item.description}
                submenuKey={item.submenuKey}
                submenuItems={item.submenuItems}
                activeSubmenuHoverTop={activeSubmenuHoverTop}
                setActiveSubmenuHoverTop={setActiveSubmenuHoverTop}
                isDesktopSubmenuOpen={isDesktopSubmenuOpen}
                setIsDesktopSubmenuOpen={setIsDesktopSubmenuOpen}
                menuOpen={menuOpen}
              />
            ) : (
              <a
                href={item.href}
                target={item.target}
                className={item.className || "menu-header"}
                onClick={item.onClick}
              >
                {item.icon}
                {item.label}
                {item.description && (
                  <span className="menu-description">{item.description}</span>
                )}
              </a>
            )}
          </Container>
        );
      })}
    </Container>
  );
};

const Navigation = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeMenuStack, setActiveMenuStack] = useState([]);

  const handleScheduleDemoClick = (e) => {
    if (window.fbq) {
      fbq("trackCustom", "Book demo", { content_name: "index-new" });
    }
    return true;
  };

  const handleMenuOnClick = () => {
    setActiveMenuStack([]);
    setMenuOpen(!menuOpen);
  };

  // if link has submenu include submenu key and submenu links
  // IMPORTANT SUBMENU KEYS MUST BE UNIQUE
  const menuItems = [
    {
      label: "Products",
      submenuKey: "products",
      submenuItems: [
        {
          label: "For Art Galleries",
          description: "Resources For Gallery Owners",
          submenuKey: "for-galleries",
          submenuItems: [
            {
              icon: "/assets/img/icons/travel_briefcase_1x.webp",
              label: "Manager",
              href: "/manager-for-galleries",
              description: "All-in-one gallery management",
            },
            {
              icon: "/assets/img/icons/drag_drop_1x.webp",
              label: "Website Builder",
              href: "/art-websites-for-galleries",
              description: "Drag and Drop beautiful websites",
            },
            {
              icon: "/assets/img/icons/circle_i_1x.webp",
              label: "Pricing",
              href: "/gallery-pricing",
              description: "Simple pricing",
            },
            {
              icon: "/assets/img/icons/customer_service_1x.webp",
              label: "Book A Demo",
              href: "/gallery-demo",
              target: "_blank",
              description: "Got Questions? Let's Chat.",
              onClick: handleScheduleDemoClick,
            },
            {
              icon: "/assets/img/icons/diagram_nodes_1x.webp",
              label: "Integrations",
              href: "/integrations",
              description: "Integrate with other platforms",
            },
            {
              icon: "/assets/img/icons/computer_desktop_1x.webp",
              label: "Website Examples",
              href: "/gallery-website-examples",
              description: "See some real life examples",
            },
          ],
        },
        {
          label: "For Artists",
          description: "Resources For Artists",
          submenuKey: "for-artists",
          submenuItems: [
            {
              icon: "/assets/img/icons/travel_briefcase_1x.webp",
              label: "Manager",
              href: "/manager-for-artists",
              description: "All-in-one studio management",
            },
            {
              icon: "/assets/img/icons/drag_drop_1x.webp",
              label: "Website Builder",
              href: "/artist-websites",
              description: "Drag and Drop beautiful websites",
            },
            {
              icon: "/assets/img/icons/circle_i_1x.webp",
              label: "Pricing",
              href: "/artist-pricing",
              description: "Simple pricing",
            },
            {
              icon: "/assets/img/icons/union_1x.webp",
              label: "Artist Resources",
              href: "/artist-resources",
              description: "Library of educational content",
            },
            {
              icon: "/assets/img/icons/computer_laptop_1x.webp",
              label: "Website Examples",
              href: "/artist-website-examples",
              description: "See some real life examples",
            },
            {
              icon: "/assets/img/icons/image_1x.webp",
              label: "Art Contest Winners",
              href: "/art-contest-winners",
              description: "ArtCloud open call 2023 winners",
            },
          ],
        },
        {
          label: "For Jewelry Galleries",
          description: "Resources For Jewelers",
          submenuKey: "for-jewelry",
          submenuItems: [
            {
              icon: "/assets/img/icons/travel_briefcase_1x.webp",
              label: "Manager",
              href: "/manager-for-jewelry",
              description: "All-in-one gallery management",
            },
            {
              icon: "/assets/img/icons/drag_drop_1x.webp",
              label: "Website Builder",
              href: "/art-websites-for-galleries",
              description: "Drag and Drop beautiful websites",
            },
            {
              icon: "/assets/img/icons/circle_i_1x.webp",
              label: "Pricing",
              href: "/gallery-pricing",
              description: "Simple pricing",
            },
            {
              icon: "/assets/img/icons/customer_service_1x.webp",
              label: "Book A Demo",
              href: "/gallery-demo",
              target: "_blank",
              description: "Got Questions? Let's Chat.",
              onClick: handleScheduleDemoClick,
            },
            {
              icon: "/assets/img/icons/computer_laptop_1x.webp",
              label: "Website Examples",
              href: "/jewelry-gallery-website-examples",
              description: "See some real life examples",
            },
          ],
        },
      ],
    },
    {
      label: "Features",
      submenuKey: "features",
      submenuItems: [
        {
          label: "Marketing and Sales",
          description: "Features to grow your revenue",
          submenuKey: "marketing-and-sales",
          submenuItems: [
            {
              icon: "/assets/img/icons/envelope_open_sparkle_1x.webp",
              label: "Email Campaigns",
              href: "/features/email-campaigns",
              description: "Beautiful email newsletters"
            },
            {
              icon: "/assets/img/icons/opportunity_tracker_1x.webp",
              label: "Opportunity Tracking",
              href: "/features/opportunity-tracking",
              description: "Powerful sales tracking"
            },
            {
              icon: "/assets/img/icons/paper_1x.webp",
              label: "Collateral",
              href: "/features/collateral",
              description: "Branded business documents"
            },
            {
              icon: "/assets/img/icons/pen_1x.webp",
              label: "Email Templates",
              href: "/features/email-templates",
              description: "Save time, pre-write responses"
            },
            {
              icon: "/assets/img/icons/hand_snap_1x.webp",
              label: "Follow-Up Reminders",
              href: "/features/follow-up-reminders",
              description: "Never forget a follow up"
            },
            {
              icon: "/assets/img/icons/users_1x.webp",
              label: "Client Management",
              href: "/features/client-management",
              description: "Understand your clients"
            },
          ],
        },
        {
          label: "Inventory Management",
          description: "Do more with your inventory",
          submenuKey: "inventory-management",
          submenuItems: [
            {
              icon: "/assets/img/icons/magnifying_glass_1x.webp",
              label: "Best In-Class Search",
              href: "/features/search-feature",
              description: "Fast & Robust Search"
            },
            // {
            //   label: "Collateral Creation",
            //   href: "/features/collateral-creation",
            //   description: "Create branded Collateral"
            // },
            {
              icon: "/assets/img/icons/diagram_nodes_1x.webp",
              label: "Exports",
              href: "/features/exports",
              description: "Customizable exports and reports"
            },
            {
              icon: "/assets/img/icons/union_1x.webp",
              label: "History Tracking",
              href: "/features/history-tracking",
              description: "Automatic history tracking"
            },
            {
              icon: "/assets/img/icons/folder_1x.webp",
              label: "Batch Editing",
              href: "/features/batch-editing",
              description: "Powerful editing"
            },
            {
              icon: "/assets/img/icons/qr_code_1x.webp",
              label: "QR Codes",
              href: "/features/qr-codes",
              description: "QR Codes are back!"
            },
          ],
        },
        {
          label: "Websites",
          description: "Improve your online presence",
          submenuKey: "websites",
          submenuItems: [
            {
              icon: "/assets/img/icons/drag_drop_1x.webp",
              label: "SEO",
              href: "/features/seo",
              description: "Automatic SEO ensures high ranking"
            },
            {
              icon: "/assets/img/icons/shopping_cart_1x.webp",
              label: "E-Commerce",
              href: "/features/e-commerce",
              description: "Turn Key Ecommerce"
            },
            // {
            //   label: "Inventory Creation",
            //   href: "/features/inventory-creation",
            // },
            {
              icon: "/assets/img/icons/computer_desktop_1x.webp",
              label: "CRM Integration",
              href: "/features/crm-integration",
              description: "All inquiries go directly to your CRM"
            },
            {
              icon: "/assets/img/icons/image_1x.webp",
              label: "Drag And Drop Builder",
              href: "/features/drag-and-drop-builder",
              description: "No code, mess, no problems"
            },
            // {
            //   label: "Professional Builder",
            //   href: "/features/professional-builder",
            // },
            {
              icon: "/assets/img/icons/users_1x.webp",
              label: "Inventory Integration",
              href: "/features/inventory-integration",
              description: "No more double data entry"
            },
          ],
        },
        {
          label: "Analytics and Reporting",
          description: "Powerful & Personalized Reporting",
          submenuKey: "analytics-and-reporting",
          submenuItems: [
            {
              icon: "/assets/img/icons/calculator_1x.webp",
              label: "Consignment Reports",
              href: "/features/consignment-reports",
              description: "Easily calculated every month"
            },
            {
              icon: "/assets/img/icons/map_pin_1x.webp",
              label: "Tax Reports",
              href: "/features/tax-reports",
              description: "Easily calculate monthly taxes"
            },
            {
              icon: "/assets/img/icons/clipboard_1x.webp",
              label: "Top Contacts Report",
              href: "/features/top-contacts-report",
              description: "Discover your top collectors"
            },
          ],
        },
      ],
    },
    // {
    //   label: "Pricing",
    //   submenuKey: "pricing",
    //   submenuItems: [
    //     {
    //       label: "For Galleries",
    //       href: "/gallery-pricing",
    //     },
    //     {
    //       label: "For Artists",
    //       href: "/artist-pricing",
    //     },
    //   ],
    // },
    {
      label: "Marketplace",
      href: "https://artcloud.market",
      target: "_blank",
    },
    // {
    //   label: "About",
    //   href: "/about"
    // },
    {
      label: "About",
      submenuKey: "about",
      submenuItems: [
        {
          label: "About Us",
          href: "/about",
        },
        {
          label: "Knowledge Base",
          href: "https://help.artcloud.com/knowledge",
          target: "_blank"
        },
        {
          label: "Marketplace",
          href: "https://artcloud.market",
          target: "_blank"
        }
      ]
    },
    {
      label: "Login",
      href: "/login",
      isMobileOnly: true,
    },
    {
      label: "Try for Free",
      href: "/register",
      className: "btn btn--blue",
      isMobileOnly: true,
    },
  ];

  return (
    <Container name="navigation">
      <Container name="navigation-menu-bar">
        <MobileMenuIcon handleOnClick={handleMenuOnClick} />
        <Menu
          activeMenuStack={activeMenuStack}
          setActiveMenuStack={setActiveMenuStack}
          menuItems={menuItems}
          menuOpen={menuOpen}
          handleMenuOnClick={handleMenuOnClick}
        />
        <Container name="navigation-logo">
          <a href="/">
            <img
              src="/assets/img/logos/light-main.svg"
              height="36px"
              width="182px"
              title="ArtCloud"
              alt="ArtCloud"
            />
          </a>
        </Container>
        <Container name="navigation-login">
          <a href="/login" className="menu-header">
            Login
          </a>
          <a href="/register" className="btn btn--blue">
            Try for Free
          </a>
        </Container>
      </Container>
    </Container>
  );
};

export default Navigation;
